import { useEffect, useState } from 'react';
import { openLoginModal } from '~spa/Utils/WrapperIntegration/Ucf';
import { addToBetslip } from '~shared/utils/betslip';
import { rewriteUrl } from '~shared/utils/uriAliases';
import { navigateTo } from '~spa/Utils/NavigationAdapter';
import { changeBrowserURI } from '~spa/Utils/WrapperIntegration/Ucf';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import { post } from '~shared/utils/http';
import { seoUrlTournament } from '~spa/Utils/SeoUrls';
import {
    SPORTCALLER_TOURNAMENT_URL,
    SPORTCALLER_SPORT_SLUG,
    SPORTCALLER_CATEGORY_SLUG,
    SPORTCALLER_TOURNAMENT_SLUG,
    SPORTCALLER_SLUG,
 } from './constants';

/**
* Checks page type
* @param {String} currentUrlPath url path
* @returns {Boolean} whether page is Sportcaller page
*/
export const isSportcallerPage = (currentUrlPath) => {
    return Boolean(currentUrlPath.includes(SPORTCALLER_SLUG));
};

export const stripUrl = (url) => {
    return url.endsWith('/') ? url.slice(0, -1) : url;
};

export const useIframe = (iframeUrl) => {
    const [nflUrl, setNflUrl] = useState(null);

    const getData = async () => {
        const url = buildSpectateUrl(SPORTCALLER_TOURNAMENT_URL);
        const response = await post(url, {
            sport: SPORTCALLER_SPORT_SLUG,
            categorySlug: SPORTCALLER_CATEGORY_SLUG,
            tournamentSlug: SPORTCALLER_TOURNAMENT_SLUG,
        });
        let tournamentUrl = '/';

        if (response.ok) {
            const tournamentId = await response.json();
            if (tournamentId) {
                tournamentUrl = seoUrlTournament(`/${SPORTCALLER_SPORT_SLUG}/${SPORTCALLER_CATEGORY_SLUG}/${SPORTCALLER_TOURNAMENT_SLUG}`, tournamentId);
            }
        }

        setNflUrl(tournamentUrl);
    };

    useEffect(() => {
        if (nflUrl) {
            window.addEventListener('message', iframeEvent);
        } else {
            getData();
        }

        return () => {
            window.removeEventListener('message', iframeEvent);
        };
    }, [nflUrl]);

    const iframeEvent = (event) => {
        const { origin, data } = event;
        if (stripUrl(origin) === stripUrl(iframeUrl)) {
            switch (data.type) {
                case 'showLoginPopup':
                    openLoginModal();
                    break;
                case 'addSelections':
                    data.selections.forEach((selection) => {
                        addToBetslip([{
                            single: selection,
                        }],
                        'sportcaller');
                    });
                    changeBrowserURI(rewriteUrl(nflUrl));
                    navigateTo(nflUrl);
                    break;
                default:
                    break;
            }
        }
    };
};
